import { render, staticRenderFns } from "./WeeklyReportViewSalesOrders.vue?vue&type=template&id=3ed385e7"
import script from "./WeeklyReportViewSalesOrders.vue?vue&type=script&lang=js"
export * from "./WeeklyReportViewSalesOrders.vue?vue&type=script&lang=js"
import style0 from "./WeeklyReportViewSalesOrders.vue?vue&type=style&index=0&id=3ed385e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports